import React, { useState, useEffect, useRef } from 'react'
import { mobile } from '../Services/Agent'
import "./Header.scss"
import { useLocation, Link } from 'react-router-dom';
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing";

function vw1920(px) {
    return (px / 1920) * 100;
}

function vw(px) {
    return (px / 640) * 100;
}

export default function Header() {
    const [open, setOpen] = useState(false)
    let path = useLocation().pathname
    let headerRef = useRef();
    let isArticle = path === "/" ? false : true

    function handleBack() {
        // let f_title = document.querySelector(".fight_title")
        // f_title.scrollIntoView()
        // window.scrollTo(0 , mobile() ? vw(300) : vw1920(1000))

        if (window.history.length <= 1) {
            window.location.href = "https://z.ynet.co.il/short/content/2020/templemount/#/";
            return;
        }
        window.history.back();
    }

    return (
        <header ref={headerRef} className={`header ${path !== "/" && "h_article"}`}>
            <div className="left_wrapper">
                <div className="ngishut icon" onClick={() => openNegishut()}></div>
                <div className={`share icon ${open && "open"}`} onClick={() => setOpen(!open)}></div>
                <div className={`fb icon ${open && "open"}`} onClick={() => shareFacebook()}></div>
                <div className={`wa icon ${open && "open"}`} onClick={() => shareWhatsapp()}></div>
                {
                    path !== "/" && <Link className="back" onClick={() => handleBack()}>חזרה לכתבות</Link>
                }
            </div>
            <div className="right_wrapper">
                <a target="_blank" href="https://www.ynet.co.il/home/0,7340,L-8,00.html" className="ynet icon"></a>
                {
                    path !== "/" && <div className="meriva">הר המריבה</div>
                }
            </div>
        </header>
    )
}
